import React, { PureComponent } from 'react';

interface IProps {
  license: number;
  group?: number;
  params?: {
    name: string;
    value: any;
  };
  visitor?: {
    name: string;
    email: string;
  };
  chatBetweenGroups: boolean;
}

export default class Live extends PureComponent<IProps> {
  componentDidMount() {
    this.loadLiveChatApi.bind(this)();
  }

  loadLiveChatApi() {

    const liveChat = (window as any).__lc || {};
    liveChat.license = this.props.license;
    liveChat.group = this.props.group;
    liveChat.chat_between_groups = this.props.chatBetweenGroups;
    liveChat.params = this.props.params;
    liveChat.visitor = this.props.visitor;
    (window as any).__lc = liveChat;

    if (!(window as any).LC_API) {
      const liveChatScript = document.createElement('script');
      liveChatScript.type = 'text/javascript';
      liveChatScript.async = true;
      liveChatScript.src =
        ('https:' === document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(liveChatScript, s);
    }
  }

  render() {
    if (!!(window as any).LC_API) {
      if((window as any).LC_API.open_chat_window) (window as any).LC_API.open_chat_window();
    }

    return <div></div>;
  }

  componentWillUnmount() {
    if (!!(window as any).LC_API) {
      if((window as any).LC_API.hide_chat_window) (window as any).LC_API.hide_chat_window();
      if((window as any).LC_API.close_chat) (window as any).LC_API.close_chat();

      delete (window as any).LC_API;
      delete (window as any).__lc;
      delete (window as any).__lc_inited;

    }
  }
}
